import CartGTM from '@global/gtm/class/cartClass';

import {
  fireCartCheckoutGAEvent,
  fireRemoveFromCartGAEvent,
  fireViewCartEvent,
} from '@global/gtm/base';

export function fireCartCheckout(payload) {
  window.dataLayer = window.dataLayer || [];

  const step1GTM = new CartGTM();

  const getUserSelect = step1GTM.getUserSelect(payload);
  const productPriceInfo = CartGTM.getProductPrice(payload.memo);
  const transformProductInfo = CartGTM.transformProductInfo(payload);

  fireCartCheckoutGAEvent({
    value: productPriceInfo.payPrice,
    coupon: getUserSelect.couponType,
    items: transformProductInfo,
  });

  // 為了購物車第二步的資料
  CartGTM.setDataToLocalStorage({
    getUserSelect,
    productPriceInfo,
    transformProductInfo,
  });
}

/**
 * remove item from cart
 * @param {object} itemInfo - The item information.
 * @param {string} itemInfo.customMarketID - The custom market ID.
 * @param {string} itemInfo.clickProductName - The click product name.
 * @param {string} itemInfo.color - The color of the item.
 * @param {number} itemInfo.price - The price of the item.
 * @param {number} itemInfo.quantity - The quantity of the item.
 * @param {string} itemInfo.size - The size of the item.
 * @param {string} itemInfo.barCode - The barcode of the item.
 * @return {undefined}
 */
export function fireRemoveFromCart(itemInfo) {
  window.dataLayer = window.dataLayer || [];

  const { barCode, clickProductName, color, customMarketID, price, quantity, size, subtotal } =
    itemInfo;

  fireRemoveFromCartGAEvent({
    value: subtotal || price * quantity, // 加價購沒有 subtotal
    items: [
      {
        affiliation: color, // 應該要放供貨公司，但 GTM 廠商寫錯，數據那邊表示只能將錯就錯
        item_brand: size, // 應該要放商品品牌，但 GTM 廠商寫錯，數據那邊表示只能將錯就錯
        item_id: customMarketID.split('SZ')[0],
        item_list_name: '購物車清單',
        item_name: clickProductName,
        item_variant: barCode, // 應該要放顏色，但 GTM 廠商寫錯，數據那邊表示只能將錯就錯
        price,
        quantity,
      },
    ],
  });
}

export function fireViewCart(cartInfo) {
  window.dataLayer = window.dataLayer || [];

  const productPriceInfo = CartGTM.getProductPrice(cartInfo.memo);
  const transformProductInfo = CartGTM.transformProductInfo(cartInfo);

  fireViewCartEvent({
    value: productPriceInfo.payPrice,
    items: transformProductInfo,
  });
}
